export default __webpack_public_path__ + "static/media/spratt7.b3e5090e.jpg";